/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
} from '../../../services/settings/appStyle/global.style';
import { LoadingModal, UserContainer } from './user.style';
import {
  DeleteConfirmationModal,
  DropdownButton,
  Loader,
  Table,
  IconButton as IconButtonWithText,
} from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import UserService, { confirmUser } from '../../../services/bioplus-services/user';
import Company from '../../../services/bioplus-services/company';
import { AddPlusIcon, DeleteIcon, EditIcon, UserIcon } from '../../../Components/icons';
import { InviteUserModal, PartnerUserEditModal } from './modals';
import { useCompany } from '../../../hooks/CompanyContext';
import { partnerOption, visitorOption } from './constants';
import { IntlMessages } from '../../../helper/langHelper';
import moment from 'moment';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { exportExcelFile } from '../../../helper/exportExcelHelper';
import { convertToUserTimeZoneDateTime } from '../../../helper/dataFormat';
import { WarningModal } from '../../../Components/uielements/deleteComfirmationModal/deleteConfirmationModal';
import { LoadingContent } from '../EmailTemplate/emailTemplate.style';

const NON_DELETABLE_ROLES = ['ADMIN', 'PARTNER', 'VISITOR'];

const AdminRoles = () => {
  const [editUser, setEditUser] = useState();
  const [deleteUser, setDeleteUser] = useState();
  const userContext = useUserContext();
  const companyContext = useCompany();
  const companyFilter = companyContext?.company?._id;
  // const partnerId = userContext.company.companyId?.id;
  const partnerId = userContext.company?.partnerId;
  // const roleId = userContext?.company?._id;
  const [allUsers, setAllUsers] = useState(undefined);
  const userTimeZone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

  const { company, userPermission } = userContext;
  const userEmail = company?.createdBy;
  const isUserAllowToManage = userPermission?.find((permission) => permission?.label === 'user');

  // Permission flags derived from the "user" permission object
  const canManageUser = !!isUserAllowToManage?.isManage;
  const canDownloadReport = !!isUserAllowToManage?.isReport;
  const canCreateUser = !!isUserAllowToManage?.isCreate;

  function extractData(dataArray) {
    if (dataArray) {
      const extractedData = dataArray?.map((item) => {
        return {
          Name: `${item?.userId?.firstName} ${item?.userId?.lastName}`,
          accountManager: item?.companyId?.name,
          email: item?.userId?.email,
          role:
            item.role === 'VISITOR'
              ? 'GUEST'
              : item.role === 'PARTNER'
              ? 'DISTRIBUTOR'
              : item.label || item.role,
          mobile: item?.userId?.phone,
          lastLogin: item?.userId?.lastLogin
            ? convertToUserTimeZoneDateTime(item?.userId?.lastLogin, userTimeZone)
            : 'N/A',
          createdAt: moment(item?.createdAt)?.format('DD-MM-YYYY'),
        };
      });
      return { bioplusUsers: extractedData };
    }
  }

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();
  const [isAddUserModal, setIsAddUserModal] = useState();

  const companyId = userContext?.company?.companyId?.id;

  const usersQuery = useQuery(['adminRoles', companyFilter, name, page, pageSize], () =>
    UserService.listByAdmin(name, page, pageSize, companyFilter)
  );
  const userTableData = usersQuery?.data?.data ?? [];
  const queryClient = useQueryClient();

  useQuery(['allAdminRoles'], () => UserService.listAllUserByAdmin(), {
    enabled: !allUsers,
    onSuccess: (data) => {
      setAllUsers(data?.data ?? []);
    },
  });

  const deleteMutation = useMutation(
    (data) =>
      Company.removeUserFromCompany(data?.companyId?._id, data?.userId?._id, deleteUser?._id),
    {
      onSuccess: async () => {
        alert('Member deleted successfully.');
        await queryClient.invalidateQueries('adminRoles');
      },
    }
  );

  const confirmUserMutation = useMutation((email) => confirmUser({ email }), {
    onSuccess: async () => {
      alert('Member verified successfully.');
      await queryClient.invalidateQueries('adminRoles');
    },
    onError: async () => {
      alert('Member Already Confirmed!');
    },
  });

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  //   table coulmns
  const userColumns = useMemo(() => {
    const cols = [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName ?? '--'} ${
              cellData?.row?.original?.userId?.lastName ?? '--'
            }`}
          </TableCell>
        ),
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.account.owner" />,
        accessor: 'companyId.name',
        width: '18%',
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'userId.email',
        width: '18%',
      },
      {
        Header: <IntlMessages id="table.col.role" />,
        accessor: 'label',
        width: '10%',
        // Cell: (cellData) => (
        //   <TableCell>
        //     {cellData?.row?.original?.role === 'VISITOR'
        //       ? 'GUEST'
        //       : cellData?.row?.original?.role === 'PARTNER'
        //       ? 'DISTRIBUTOR'
        //       : cellData?.row?.original?.role}
        //   </TableCell>
        // ),
      },
      {
        Header: <IntlMessages id="table.col.mobile.no" />,
        accessor: 'userId.phone',
      },
      {
        Header: <IntlMessages id="table.col.last.login" />,
        accessor: 'lastLogin',
        width: '13%',
        Cell: (cellData) => (
          <TableCell>
            {cellData?.row?.original?.userId?.lastLogin
              ? `${convertToUserTimeZoneDateTime(
                  cellData?.row?.original?.userId?.lastLogin,
                  userTimeZone
                )}`
              : 'N/A'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.createdAt" />,
        accessor: 'createdAt',
        Cell: (cellData) => <TableCell>{moment(cellData?.value)?.format('DD-MM-YYYY')}</TableCell>,
        width: '10%',
      },
      {
        Header: <IntlMessages id="nav.subscriptionPlans" />,
        accessor: 'subscription',
        Cell: (cellData) => {
          const rowData = cellData?.row?.original;
          const teamStatus = rowData?.userId?.team;
          const subscription = rowData?.subscription;

          // Determine subscription display text based on team status
          const getSubscriptionText = () => {
            // team: 1 => Team member
            if (teamStatus === 1) {
              return 'Team';
            }

            // team: 2 => FREE user
            if (teamStatus === 2) {
              return 'FREE';
            }

            // team: 0 => Not a team member, check subscription
            if (teamStatus === 0) {
              // If no subscription, it's Mobile (FREE) plan
              if (!subscription || !subscription.subscriptionId) {
                return 'Mobile (FREE)';
              }

              // If subscription exists, show the purchased plan name
              return (
                subscription?.subscriptionId?.labelName ||
                subscription?.subscriptionId?.name ||
                '--'
              );
            }

            // Fallback for undefined team status
            return 'Mobile (FREE)';
          };

          return <TableCell>{getSubscriptionText()}</TableCell>;
        },
      },
    ];

    // Only show the Actions column (Edit/Delete) if the user has manage permission
    if (canManageUser) {
      cols.push({
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '18%',
      });
    }

    return cols;
  }, [userTimeZone, canManageUser]);

  const handleClosed = () => {
    setEditUser(undefined);
  };
  const handleConfirmUser = (data) => {
    const email = data?.userId?.email;
    if (!email) return;
    confirmUserMutation.mutate(email);
  };

  const actionList = [
    (data) => (
      <IconButton onClick={() => setEditUser(data)}>
        <EditIcon />
      </IconButton>
    ),

    // (data) => (
    //   <IconButton onClick={() => handleConfirmUser(data)}>
    //     <UserIcon />
    //   </IconButton>
    // ),
    (data) => {
      const isDeleteDisabled =
        NON_DELETABLE_ROLES.includes(data?.role) || userEmail === data?.userId?.email;
      return (
        <IconButton
          onClick={() => !isDeleteDisabled && setDeleteUser(data)}
          disabled={isDeleteDisabled}
          style={isDeleteDisabled ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
        >
          <DeleteIcon style={{ width: '19px', height: '19px' }} />
        </IconButton>
      );
    },
  ];

  const handleDeleteUser = (data) => {
    deleteMutation.mutate(data);
    setDeleteUser(undefined);
  };

  if (usersQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  const excelFormatData = extractData(allUsers ?? []);
  const fileName = `Members-${moment().format('DD-MM-YYYY-hh.mm A')}.xlsx`;
  const fileNameCsv = `Members-${moment().format('DD-MM-YYYY-hh.mm A')}.csv`;
  const columnConfig = [
    { header: 'Name', key: 'Name', width: 30 },
    { header: 'Account Manager', key: 'accountManager', width: 30 },
    { header: 'Email', key: 'email', width: 30 },
    { header: 'Role', key: 'role', width: 20 },
    { header: 'Mobile No', key: 'mobile', width: 20 },
    { header: 'Last Login', key: 'lastLogin', width: 20 },
    { header: 'Created At', key: 'createdAt', width: 20 },
  ];

  const handleClickItem = (item) => {
    switch (item?.key) {
      case 'excel':
        exportExcelFile(excelFormatData, fileName, columnConfig);
        break;
      case 'pdf':
        break;
      case 'csv':
        exportExcelFile(excelFormatData, fileNameCsv, columnConfig);
        break;
      default:
        break;
    }
  };
  const handleClosedAddUserModal = () => {
    setIsAddUserModal(false);
  };

  return (
    <StyledContainer>
      <UserContainer>
        <HeaderTitle>
          <IntlMessages id="nav.roles" />
        </HeaderTitle>{' '}
        <TwoColumns style={{ gap: '15px' }}>
          {canCreateUser && companyFilter && (
            <IconButtonWithText
              text={<IntlMessages id="button.text.add.user" />}
              icon={<AddPlusIcon />}
              onClick={() => {
                setIsAddUserModal(true);
              }}
            />
          )}
          {excelFormatData && canDownloadReport && (
            <DropdownButton
              noOfColoumns={1}
              buttonArray={[
                { key: 'excel', title: 'Export as Excel', icon: <CloudDownloadIcon /> },
                // { key: 'pdf', title: 'Export as PDF', icon: <PictureAsPdfIcon /> },
                { key: 'csv', title: 'Export as CSV', icon: <SimCardDownloadIcon /> },
              ]}
              onClick={handleClickItem}
            />
          )}
        </TwoColumns>
      </UserContainer>
      <TableWrapper>
        <Table
          data={userTableData}
          columns={userColumns}
          hasFooter={true}
          actions={actionList}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={usersQuery?.data?.total || 0}
        />
      </TableWrapper>
      {editUser && editUser !== undefined && (
        <PartnerUserEditModal
          onClose={handleClosed}
          data={editUser}
          userRole="partner"
          // options={editUser?.role === 'VISITOR' ? visitorOption : []}
          options={
            editUser?.role === 'VISITOR'
              ? visitorOption
              : editUser?.role === 'OWNER'
              ? partnerOption
              : []
          }
          invalidateQuery="adminRoles"
        />
      )}
      {confirmUserMutation.isLoading && (
        <LoadingModal>
          <LoadingContent>
            <Loader loadingText="Confirming user..." />
          </LoadingContent>
        </LoadingModal>
      )}
      {deleteUser && deleteUser?.role !== 'PARTNER' && deleteUser?.role !== 'ADMIN' && (
        <DeleteConfirmationModal
          onClose={() => {
            setDeleteUser(undefined);
          }}
          message={
            <IntlMessages
              id="delete.comfirmation.text.user"
              values={{
                user: ` ${deleteUser?.userId?.firstName} ${deleteUser?.userId?.lastName}`,
              }}
            />
          }
          onConfirm={() => handleDeleteUser(deleteUser)}
        />
      )}
      {deleteUser && (deleteUser.role === 'PARTNER' || deleteUser.role === 'ADMIN') && (
        <WarningModal
          onClose={() => setDeleteUser(undefined)}
          message={`The user '${deleteUser?.userId?.firstName} ${deleteUser?.userId?.lastName}' assigned the '${deleteUser?.label}' role, is not permitted to perform the delete action.`}
        />
      )}{' '}
      {isAddUserModal && (
        <InviteUserModal onClose={handleClosedAddUserModal} companyId={companyFilter} />
      )}
    </StyledContainer>
  );
};

export default AdminRoles;
